import { useEffect, useState } from "react";

/**
 * Follows `value`, but only once it has stopped changing for `delayMs`.
 * Lets a list keep still while someone is mid-word.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
